import React, { useEffect, useRef } from 'react';
import { T } from '../assets/theme';

// Small floating menu shown when right-clicking a marker on any assessment
// map — offers a single "Edit ..." action, opening whichever modal the
// caller wired up via onEdit. Reused for both obstacles (EditObstacleModal)
// and aerodromes (EditAerodromeModal) — `obstacle` just needs a `.name`.
// Closes on outside click, Escape, or scroll (its fixed x/y would otherwise
// drift from the marker).
export default function ObstacleContextMenu({ x, y, obstacle, onEdit, onClose, actionLabel = 'Edit Obstacle' }) {
    const ref = useRef(null);

    useEffect(() => {
        const handleClick = (e) => { if (ref.current && !ref.current.contains(e.target)) onClose(); };
        const handleKey = (e) => { if (e.key === 'Escape') onClose(); };
        document.addEventListener('mousedown', handleClick);
        document.addEventListener('keydown', handleKey);
        document.addEventListener('scroll', onClose, true);
        return () => {
            document.removeEventListener('mousedown', handleClick);
            document.removeEventListener('keydown', handleKey);
            document.removeEventListener('scroll', onClose, true);
        };
    }, [onClose]);

    if (!obstacle) return null;

    const left = Math.min(x, window.innerWidth - 200);
    const top = Math.min(y, window.innerHeight - 90);

    return (
        <div ref={ref} style={{
            position: 'fixed', top, left, zIndex: 3000,
            background: T.bg1, border: `1px solid ${T.border}`, borderRadius: 8,
            boxShadow: '0 4px 16px rgba(0,0,0,0.5)', minWidth: 180, overflow: 'hidden',
        }}>
            <div style={{ padding: '8px 12px', fontSize: 11, fontWeight: 700, color: T.muted, borderBottom: `1px solid ${T.border}33`, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                {obstacle.name || 'Obstacle'}
            </div>
            <button
                onClick={() => onEdit(obstacle)}
                style={{
                    display: 'flex', alignItems: 'center', gap: 8, width: '100%', textAlign: 'left',
                    padding: '8px 12px', background: 'none', border: 'none', color: T.white,
                    fontSize: 12, cursor: 'pointer',
                }}
                onMouseEnter={e => e.currentTarget.style.background = 'rgba(255,255,255,0.06)'}
                onMouseLeave={e => e.currentTarget.style.background = 'none'}
            >
                ✏️ {actionLabel}
            </button>
        </div>
    );
}
